import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyCgWMQB9XMzNTOr54SDWMcqADYM8ivwzgs",
  authDomain: "frizlengroup.firebaseapp.com",
  databaseURL: "https://frizlengroup.firebaseio.com",
  projectId: "frizlengroup",
  storageBucket: "frizlengroup.appspot.com",
  messagingSenderId: "37901252943",
  appId: "1:37901252943:web:075cebba458bd8fddced3a",
  measurementId: "G-ELN037F29J"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')

export {
  db,
  auth,
  currentUser,
  usersCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js